// extracted by mini-css-extract-plugin
export default {"image":"ImageSkeleton_image__1sqFy"};